import { render, staticRenderFns } from "./SecurityList.vue?vue&type=template&id=2edfc73b&"
import script from "./SecurityList.vue?vue&type=script&lang=js&"
export * from "./SecurityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports